import type { ReactNode } from 'react';

/**
 * Ported from src/components/ui/Card.tsx. A card that responds to a click is a real
 * <button>: a clickable <div> is invisible to assistive tech and to getByRole.
 */
export default function Card({
  children,
  onPress,
  tone = 'surface',
  className = '',
  accessibilityLabel,
}: {
  children: ReactNode;
  onPress?: () => void;
  tone?: 'surface' | 'danger';
  className?: string;
  accessibilityLabel?: string;
}) {
  const cls = `card card-${tone} clay-${tone === 'danger' ? 'danger' : 'card'} ${className}`.trim();
  if (!onPress) return <div className={cls}>{children}</div>;
  return (
    <button type="button" onClick={onPress} aria-label={accessibilityLabel} className={`${cls} pressable card-pressable`}>
      {children}
    </button>
  );
}
